import { CreditPricing } from '@upstart/harmony/lib/legos/creditPricingType';
import { Dealer } from '../types/dealerTypes';
import { BackendService } from './BackendService';
export interface UpdateDealerRequest {
  dealerId: string;
  dealerUpdate: Partial<Dealer>;
  mergeObjectFields?: boolean;
  allowLaunchpadAlerts?: boolean;
}

export class DealerService {
  static getDealer(dealerId: string) {
    return BackendService.get<Dealer>(`/dealers/${dealerId}`, {
      params: { includeLendingConfig: true },
    });
  }

  static updateDealer({
    dealerId,
    dealerUpdate,
    mergeObjectFields,
    allowLaunchpadAlerts,
  }: UpdateDealerRequest) {
    return BackendService.put<Dealer>(`/dealers/${dealerId}`, dealerUpdate, {
      params: {
        mergeObjectFields,
        allowLaunchpadAlerts,
        includeLendingConfig: true,
      },
    });
  }

  static getCreditPricing(dealerId: string) {
    return BackendService.get<CreditPricing>(`/dealers/${dealerId}/pricing`);
  }
}
